<template>
    <div class="f-list-page-page veui-pagination">
        <div class="veui-pagination-switch">
            <div
                :class="{
                    'veui-pagination-prev': true,
                    'veui-disabled': page === 1 || pageCount === 0,
                    'veui-link': true
                }"
                aria-label="上一页"
                @click="handlePageClick(pageNavHref.prev)">
                <veui-icon name="chevron-left"></veui-icon>
            </div>
            <ul class="veui-pagination-pages">
                <li
                    v-for="item in pageIndicatorSeries"
                    :key="getKey(item)"
                    :class="{
                        'veui-pagination-page': true,
                        'veui-active': item.current
                    }">
                    <div
                        :class="{
                            'veui-current': item.current,
                            'veui-disabled': item.current,
                            'veui-pagination-more': item.more,
                            'veui-link': true
                        }"
                        @click="handlePageClick(item)">
                        <template v-if="item.more">
                            <veui-icon
                                class="veui-pagination-more-ellipsis"
                                name="ellipsis-h"
                            />
                        </template>
                        <template v-else>{{ item.text }}</template>
                    </div>
                </li>
            </ul>
            <div
                :class="{
                    'veui-pagination-next': true,
                    'veui-disabled': page === pageCount || pageCount === 0,
                    'veui-link': true
                }"
                @click="handlePageClick(pageNavHref.next)">
                <veui-icon name="chevron-right"></veui-icon>
            </div>
        </div>
    </div>
</template>

<script>
import {Icon} from 'veui';
import 'veui-theme-one-icons';
export default {
    components: {
        'veui-icon': Icon
    },
    props: {
        page: {
            'type': Number,
            'default': 1
        },
        total: {
            'type': Number,
            'default': 1
        },
        pageSize: {
            'type': Number,
            'default': 20
        },
        pageCount: {
            'type': Number,
            'default': 1
        }
    },
    methods: {
        handlePageClick(item) {
            let page = typeof item === 'number' ? item : item.page;

            if (page !== this.page) {
                this.$emit('page-change', page, event);
            }
        },
        getPageIndicator(page, more = false, forward = false) {
            return {
                page,
                more,
                forward,
                current: page === this.page,
                text: page
            };
        },
        getKey(item) {
            return `p-${item.more ? (item.forward ? 'f' : 'b') : item.page}`;
        }
    },
    computed: {
        pageIndicatorSeries() {
            let {page, pageCount, getPageIndicator} = this;

            let continuousIndicatorLength = 3;
            let boundaryIndicatorLength = 1;
            const pageIndicatorLength = 7;
            const aroundIndicatorLength = 1;

            let leftLen;
            let rightLen;
            let offsetBackward = Math.max(page - 5, 1);
            let offsetForward = Math.min(
                page + 5,
                pageCount
            );

            switch (true) {
                case pageCount <= pageIndicatorLength:
                    return getPageSeries(1, pageCount);

                case page <= boundaryIndicatorLength + aroundIndicatorLength + 2:
                    leftLen = pageIndicatorLength - boundaryIndicatorLength - 1;
                    return getPageSeries(1, leftLen)
                        .concat(getPageIndicator(offsetForward, true, true))
                        .concat(
                            getPageSeries(
                                pageCount - boundaryIndicatorLength + 1,
                                boundaryIndicatorLength
                            )
                        );

                case page >= pageCount - boundaryIndicatorLength - aroundIndicatorLength - 1:
                    rightLen = pageIndicatorLength - boundaryIndicatorLength - 1;
                    return getPageSeries(1, boundaryIndicatorLength)
                        .concat(getPageIndicator(offsetBackward, true, false))
                        .concat(
                            getPageSeries(pageCount - rightLen + 1, rightLen)
                        );

                default:
                    return getPageSeries(1, boundaryIndicatorLength)
                        .concat(getPageIndicator(offsetBackward, true, false))
                        .concat(
                            getPageSeries(
                                page - aroundIndicatorLength,
                                continuousIndicatorLength
                            )
                        )
                        .concat(getPageIndicator(offsetForward, true, true))
                        .concat(
                            getPageSeries(
                                pageCount - boundaryIndicatorLength + 1,
                                boundaryIndicatorLength
                            )
                        );
            }

            function getPageSeries(from, length) {
                let series = [];
                for (let i = 0; i < length; i++) {
                    series[i] = getPageIndicator(from + i);
                }
                return series;
            }
        },
        pageNavHref() {
            return {
                prev: this.getPageIndicator(Math.max(1, this.page - 1)),
                next: this.getPageIndicator(Math.min(this.pageCount, this.page + 1))
            };
        }
    }
};
</script>

<style>

.veui-pagination-page.veui-active {
    background-color: #eee;
}
</style>